import api from '../..'
import { ILmsProfileModel } from 'models/lmsProfile.model'

export const showProfile = (id: number | string) => {
  return api
    .get(`administration/lms_profiles/${id}`)
    .then(({ data }): ILmsProfileModel => data)
}
